import React from "react";
import { useSelector } from "react-redux";
import { RootState } from "@src/reducers/store";
import { AutoMatchBlueprintModal } from "@src/components/organisms/modals/blueprints/auto-match-blueprint-modal/auto-match-blueprint-modal";

export const BlueprintAutoMatch = () => {
  const showAutoMatchBlueprintModal = useSelector(
    (state: RootState) =>
      state.yourSlice.autoMatchBlueprintModal.showAutoMatchBlueprintModal,
  );

  return <>{showAutoMatchBlueprintModal && <AutoMatchBlueprintModal />}</>;
};
